import { z } from 'zod';
import { lensAnnotationStatesZod } from 'packages/lib/api/annotations/contract/lens-annotation';

// Task Snapshot backend design doc:
// https://docs.google.com/document/d/1Vwa54IUu139TATsfO1xPkPvQyRmAVj5zeStmx6vqu6U

const lensAnnotationSnapshotItemZod = z.object({
  isLit: z.boolean(),
  state: lensAnnotationStatesZod,
  lensId: z.number(),
  frameIndex: z.number(),
  taskToken: z.string().optional(),
  videoExtractionToken: z.string(),
  token: z.string(),
  lastUpdatedBy: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const videoAnnotationRowSnapshotItemZod = z.object({
  videoExtractionToken: z.string(),
  instructionToken: z.string(),
  taskToken: z.string().optional(),
  startFrame: z.number(),
  endFrame: z.number(),
  attributeToken: z.string(),
  token: z.string(),
  lastUpdatedBy: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const tldSnapshotItemZod = z.union([
  lensAnnotationSnapshotItemZod, // TLD Tool
  videoAnnotationRowSnapshotItemZod, // TLD Tool
]);

export const tldSnapshotZod = z.array(tldSnapshotItemZod);
export type TLDTaskSnapshot = z.infer<typeof tldSnapshotZod>;

export const evaSnapshotZod = z.array(videoAnnotationRowSnapshotItemZod);
export type EVATaskSnapshot = z.infer<typeof evaSnapshotZod>;

export const taskSnapshotMetadataZod = z.object({
  token: z.string(),
  tag: z.string().optional(),
  taskToken: z.string(),
  tableName: z.string(),
  oldAnnotationState: z.string(),
  newAnnotationState: z.string(),
  lastUpdatedBy: z.string(),
  createdAt: z.string(),
});

export const taskSnapshotResponseZod = z.array(taskSnapshotMetadataZod);

export type TaskSnapshotData<T> = z.infer<typeof taskSnapshotMetadataZod> & {
  snapshot: T;
};

export type TaskSnapshotResponse<T> = TaskSnapshotData<T>[];

export const isTaskSnapshot = (obj: unknown): boolean =>
  taskSnapshotMetadataZod.safeParse(obj).success;
